module.exports = function() {
  return new Worker(__webpack_public_path__ + "eabed805a9401fe0f945.worker.js");
};